import { useEffect, useRef, useState } from "react";
import useModal from "../hooks/useModal";
import { NumberUtil } from "../utils/number";
import PieChart from "./PieChart";
import { ColorUtil } from "../utils/color";

interface DataType {
    icon: JSX.Element;
    label: string;
    value: number | string;
}

interface FullPieChartProps {
    show: boolean;
    data?: Array<DataType>;
    dataString?: Array<DataType>;
    dataChart?: Array<DataType>;
    title: string;
    onRequestClose: () => void;
    className?: string;
    icon?: string;
}

function FullPieChart({ show, data, title, onRequestClose, className = '', dataString, dataChart, icon }: FullPieChartProps) {

    const modal = useRef<HTMLDivElement>(null);

    useModal(modal, show)

    const [dataSet, setDataSet] = useState<Array<DataType>>([])

    useEffect(() => {
        setDataSet(data.sort((a: any, b: any) => a.value - b.value))
    }, [data])



    return (
        <div className={`modal ${className} fade`} ref={modal} data-bs-backdrop="static" data-bs-keyboard="false">
            <div className="modal-dialog modal-xl" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h4 className="modal-title">{title}</h4>
                        <button title="Close" type="button" className="btn-close" onClick={() => onRequestClose()}></button>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-lg-4">
                                <div className="card-body bg-light h-100 d-flex align-items-center justify-content-center">

                                    <PieChart
                                        datasetName='Resumen'
                                        legendDisplay={false}
                                        width={250}
                                        height={250}
                                        dataset={{
                                            labels: dataSet.map(t => t.label),
                                            data: dataChart && dataChart.length > 0
                                                ? dataChart
                                                : dataSet.map((t: any) => t.value),

                                            backgroundColor: dataSet.map(t => ColorUtil.stringToRGB(t.label)),
                                            // backgroundColor: dataSet.map(t => {
                                            //     const randomNum = () => Math.floor(Math.random() * (235 - 52 + 1) + 52);
                                            //     const randomRGB = () => `rgb(${randomNum()}, ${randomNum()}, ${randomNum()})`;

                                            //     return randomRGB()
                                            // }),
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-8">

                                <div className="card-body card-body-height">
                                    <div className="table-responsive datatable-custom">
                                        <table className="table">
                                            <thead className="thead-light text-white-dark">
                                                <tr>
                                                    <th className="text-white-dark">Nombre</th>
                                                    <th className="text-white-dark">Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    dataSet.map((t, i) => (
                                                        <tr key={i}>
                                                            <td>{t.label}</td>
                                                            <td style={{ display: 'flex', alignItems: 'center' }}>
                                                                {icon && (
                                                                    <div className={`bi bi-${icon} fw-bolder`} style={{ marginRight: '8px' }} />
                                                                )}
                                                                {typeof t.value === "number" ? NumberUtil.format(t.value) : t.value}
                                                            </td>


                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="submit" className="btn btn-primary btn-sm" onClick={() => onRequestClose()}>Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default FullPieChart